import { TOptions } from 'i18next';
import { useCallback, useMemo } from 'react';
import { useTranslation as useI18next } from 'react-i18next';
import { AppTranslation } from '../../translations/types/index.types';
import {
  Paths,
  PathsTrValue,
  VariablesMap,
  getPathsToStrings,
  getValueFromPath,
  replaceVariable,
} from './types';

export const useAppTranslation = () => {
  const { i18n } = useI18next();
  const { t } = useI18next();

  const changeLanguage = useCallback(
    (lang: 'en' | 'es' | 'pt') => {
      i18n.changeLanguage(lang);
    },
    [i18n],
  );

  const tra = useCallback(
    (path: Paths<AppTranslation>, options?: TOptions) => {
      return t(path, options);
    },
    [t],
  );

  const translation: AppTranslation = useMemo(
    () =>
      ({
        global: t('global', { returnObjects: true }),
        components: t('components', { returnObjects: true }),
        pages: t('pages', { returnObjects: true }),
      } as unknown as AppTranslation),
    [t],
  );

  const translationPage = useCallback(
    function trp<T extends object>(list: (_p: AppTranslation) => T) {
      const traPageRes = list(translation);
      const pathsArray = getPathsToStrings(traPageRes);
      function tp(str: PathsTrValue<typeof pathsArray>, obj?: VariablesMap) {
        const text = getValueFromPath(traPageRes, str as string);
        if (typeof obj === 'object') {
          return replaceVariable(text, obj);
        }
        return text;
      }

      return { tp };
    },
    [translation],
  );

  return {
    t: tra,
    i18n,
    tr: t,
    translationPage,
    changeLanguage,
  };
};
